import { SideMenu } from './../components/home/sidemenu'

export tag Home
	prop db

	def routed params, state
		imba.router.refresh

	def render
		<self>
			<div[pos:fixed w:100% h:100% t:0 l:0]>
				<SideMenu list=db.list>
				# <FullscreenDisplay[pos:absolute zi:1 h:100% w:100% t:0 l:0] cover=item.cover>
